/**
 *
 * @description 使用 app type 区别 app 容器类型
 * @description 枚举详见文档: https://git.garena.com/beetalk-server-deprecated/beeshop_common/-/blob/master/protocol/beeshop_cmd.proto#L3867-3890
 * @enum {number}
 */
export enum AppType {
  Default = 0,
  Shopee = 1,
  Shopeepay = 5,
  ShopeeSeller = 29,
}

/**
 *  使用 user agent的 app_type 判断App类型
 * @returns number
 */
export function getAppType() {
  const userAgent = window?.navigator?.userAgent;
  const appType = userAgent.match(/app_type=(\d+)/);
  if (appType && appType[1]) {
    return parseInt(appType[1], 10);
  }

  return 0;
}

/**
 * 判断是否是shopeepay app
 * @returns
 */
export function isShopeeApp() {
  const appType = getAppType();
  return appType === AppType.Shopee;
}

/**
 * 判断是否是shopeepay app
 * @returns
 */
export function isShopeePayApp() {
  const appType = getAppType();
  return appType === AppType.Shopeepay;
}

/**
 * 判断是否是shopee seller app
 * @returns
 */
export function isShopeeSellerApp() {
  const appType = getAppType();
  return appType === AppType.ShopeeSeller;
}
